import { useCallback } from 'react';
import ProductAvailabilityType from '../../types/ProductAvailabilityType';

/**
 *
 * @param {Object} props
 * @param {AccountStore} props.accountStore
 * @param {ConfigStore} props.configStore
 * @param {Product} props.addToCartProduct
 * @returns {Array.<Function>}
 */
const useMaxQuantity = ({ accountStore, configStore, addToCartProduct }) => {
  const defaultMaxQuantity = 99999;
  const product = addToCartProduct;

const getMaxByPackage = () => {
    return product.sellInPackage
      ? Math.floor(
          product.free_quantity / product.package_size
        ) * product.package_size
      : product.free_quantity;
  };

  const getMaxQuantity = useCallback(() => {
    const backOrderLimit =
      configStore.product.backorderLimit > 0
        ? configStore.product.backorderLimit
        : defaultMaxQuantity;

    const normalMaxLimit = product.canBeOrderedOutOfStock
      ? defaultMaxQuantity
      : getMaxByPackage();

    const maxAccountQuantity =
      accountStore.account && accountStore.account.max_product_quantity > 0
        ? accountStore.account.max_product_quantity
        : defaultMaxQuantity;
    const maxBackorderQuantity =
      product.availability_type === ProductAvailabilityType.ALLOW_BACKORDER
        ? backOrderLimit
        : defaultMaxQuantity;
    const maxNormalProductQuantity =
      product.availability_type !== ProductAvailabilityType.ALLOW_BACKORDER
        ? normalMaxLimit
        : defaultMaxQuantity;

    return Math.min(
      maxAccountQuantity,
      maxBackorderQuantity,
      maxNormalProductQuantity,
      defaultMaxQuantity
    );
  }, [addToCartProduct.id]);

  return [getMaxQuantity]
};

export default useMaxQuantity;
